import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  uiFlags: {
    isSending: false,
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
